import React from "react";

const Feature = () => {
  return (
    <>
      <section className="dark:bg-gray-800 dark:text-gray-100">
        <div className="container max-w-xl p-6 py-12 mx-auto space-y-24 lg:px-8 lg:max-w-7xl">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-center sm:text-5xl dark:text-gray-50">
              Features
            </h2>
            <p className="max-w-3xl mx-auto mt-4 text-xl text-center dark:text-gray-400">
              As a job agency, we understand the needs and expectations of both
              job seekers and recruiters. Here are some of the things that job
              seekers and recruiters can expect when working with us:
            </p>
          </div>
          <div className="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
            <div>
              <h3 className="text-2xl font-bold tracking-tight sm:text-3xl dark:text-gray-50">
                Job Seeker
              </h3>
              <div className="mt-12 space-y-12">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 rounded-md dark:bg-blue-900 dark:text-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="w-7 h-7"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-medium leading-6 dark:text-gray-50">
                      Access to a larger pool of job openings:
                    </h4>
                    <p className="mt-2 dark:text-gray-400">
                      Wera provides job seekers with access to a broader range
                      of job openings, including positions that may not be
                      advertised through other channels.
                    </p>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 rounded-md dark:bg-blue-900 dark:text-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="w-7 h-7"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-medium leading-6 dark:text-gray-50">
                      Time saving:
                    </h4>
                    <p className="mt-2 dark:text-gray-400">
                      Job seekers can save time by using Wera app to search for
                      and apply to jobs from their mobile device or computer,
                      rather than having to visit multiple job sites or apply in
                      person.
                    </p>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 rounded-md dark:bg-blue-900 dark:text-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="w-7 h-7"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-medium leading-6 dark:text-gray-50">
                      Targeted job recommendations:
                    </h4>
                    <p className="mt-2 dark:text-gray-400">
                      Wera uses algorithms to suggest job openings that match a
                      job seeker's skills and experience, making it easier to
                      find the most relevant job listings.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div aria-hidden="true" className="mt-10 lg:mt-0">
              <img
                src="https://img.freepik.com/premium-vector/black-man-search-vacancy-with-magnifying-glass-male-character-looking-finding-new-work-opportunities-vacancies-employment-career-strategy-concept-job-search-concept_384065-1038.jpg?w=740"
                alt=""
                className="mx-auto rounded-lg shadow-lg dark:bg-gray-500"
              />
            </div>
          </div>
          <div>
            <div className="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
              <div className="lg:col-start-2">
                <h3 className="text-2xl font-bold tracking-tight sm:text-3xl dark:text-gray-50">
                  Employer
                </h3>
                <div className="mt-12 space-y-12">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center w-12 h-12 rounded-md dark:bg-blue-900 dark:text-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-7 h-7"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h4 className="text-lg font-medium leading-6 dark:text-gray-50">
                        Access to a larger pool of candidates:
                      </h4>
                      <p className="mt-2 dark:text-gray-400">
                        Wera allows employers to reach a wider audience of
                        potential candidates, increasing the chances of finding
                        the best fit for the job opening.
                      </p>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center w-12 h-12 rounded-md dark:bg-blue-900 dark:text-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-7 h-7"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h4 className="text-lg font-medium leading-6 dark:text-gray-50">
                        Reduced administrative burden:
                      </h4>
                      <p className="mt-2 dark:text-gray-400">
                        By using Wera, employers can manage the entire
                        recruitment process from a single platform, reducing
                        administrative tasks such as scheduling interviews,
                        sending follow-up emails, and collecting resumes.
                      </p>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center w-12 h-12 rounded-md dark:bg-blue-900 dark:text-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-7 h-7"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h4 className="text-lg font-medium leading-6 dark:text-gray-50">
                        Time and cost saving:
                      </h4>
                      <p className="mt-2 dark:text-gray-400">
                        Posting a job listing on Wera can save employers time
                        and money compared to traditional recruiting methods
                        such as placing ads in newspapers or on job boards.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-10 lg:mt-0 lg:col-start-1 lg:row-start-1">
                <img
                  src="https://img.freepik.com/premium-vector/man-job-interview-isolated-work-meeting-hr-management-recruitment-agency-cartoon-male-employee-business-woman-have-conversation-young-manager-boss-vector-illustration_53562-13422.jpg"
                  alt=""
                  className="mx-auto rounded-lg shadow-lg dark:bg-gray-500"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Feature;

// <section className="relative pt-16 bg-blueGray-50">
// <div className="container mx-auto ">
//   <div className="flex flex-wrap items-center ">
//     <div className="w-10/12 md:w-6/12 lg:w-4/12 px-12 md:px-4 mr-auto ml-auto -mt-78">
//       <div
//         className="relative flex flex-col min-w-0 break-words  w-full mb-6 shadow-lg rounded-lg "
//         style={{
//           backgroundColor: "#0D2644",
//         }}
//       >
//         <img
//           alt="..."
//           src="https://img.freepik.com/free-vector/man-search-hiring-job-online-from-laptop_1150-52728.jpg?w=2000"
//           className="w-full bg-dark align-middle rounded-t-lg"
//         />
//         <blockquote className="relative p-8 mb-4 ">
//           <svg
//             preserveAspectRatio="none"
//             xmlns="http://www.w3.org/2000/svg"
//             viewBox="0 0 583 95"
//             className="absolute left-0 w-full block h-95-px -top-94-px"
//           >
//             <polygon
//               points="-30,95 583,95 583,65"
//               className=" fill-current"
//               style={{ color: "#0D2644" }}
//             ></polygon>
//           </svg>
//           <h4 className="text-xl font-bold " style={{color:"#87C0F2"}}>
//             Welcome to Wera
//           </h4>
//           <p className="text-md font-light mt-2 " style={{color:"#E2EEFC"}}>
//             As a job agency, we understand the needs and expectations
//             of both job seekers and employers. Here are some of the
//             things that job seekers and recruiters can expect when
//             working with us:
//           </p>
//         </blockquote>

//       </div>
//     </div>

//     <div className="w-full md:w-6/12 px-4">
//       <div className="flex flex-wrap">
//         <div className="w-full md:w-6/12 px-4">
//           <div className="relative flex flex-col mt-4">
//             <div className="px-4 py-5 flex-auto">
//               <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
//                 <i className="fas fa-search"></i>
//               </div>
//               <h6 className="text-xl mb-1 font-semibold">Job Seeker</h6>
//               <p className="mb-4 text-blueGray-500">
//                 Opportunities that match their skills and interests
//                 <br></br>
//                 Support throughout the job search process<br></br>
//                 Regular updates on job openings<br></br>
//                 Confidentiality
//               </p>
//             </div>
//           </div>
//           <div className="relative flex flex-col min-w-0"></div>
//         </div>
//         <div className="w-full md:w-6/12 px-4">
//           <div className="relative flex flex-col min-w-0 mt-4">
//             <div className="px-4 py-5 flex-auto">
//               <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
//                 <i className="fas fa-briefcase"></i>
//               </div>
//               <h6 className="text-xl mb-1 font-semibold">Employer</h6>
//               <p className="mb-4 text-blueGray-500">
//                 Access to a large pool of qualified candidates
//                 <br></br>
//                 Streamlined hiring process<br></br>
//                 Flexibility<br></br>
//                 Expertise
//               </p>
//             </div>
//           </div>
//           <div className="relative flex flex-col min-w-0"></div>
//         </div>
//       </div>
//     </div>
//   </div>
// </div>
// </section>
